import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/icon_sprite_url_helper.js";

Handlebars.registerHelper("icon", function (name, title) {
  title = title ? ' title="' + title + '"' : "";

  return (
    "<svg" +
    title +
    ' class="icon icon-' +
    name +
    '"><use class="icon-' +
    name +
    '" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' +
    Handlebars.helpers.iconSpriteUrl() +
    "#icon-" +
    name +
    '"></use></svg>'
  );
});
